<main>
    <div class="loading-overlay" *ngIf="loading">
        <!-- show something fancy here, here with Angular 2 Material's loading bar or circle -->
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    </div>
    <router-outlet></router-outlet>
</main>
